
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M412.611765 653.552941l249.97647-249.97647V271.058824c0-84.329412-66.258824-150.588235-150.588235-150.588236s-150.588235 66.258824-150.588235 150.588236v271.058823c0 42.164706 18.070588 84.329412 51.2 111.435294zM662.588235 542.117647v-48.188235l-192.752941 192.752941 42.164706 6.023529c81.317647 0 150.588235-66.258824 150.588235-150.588235z m90.352941-60.235294c-18.070588 0-30.117647 12.047059-30.117647 30.117647v30.117647c0 117.458824-96.376471 210.823529-210.823529 210.823529-30.117647 0-60.235294-6.023529-90.352941-21.082352l-45.176471 45.17647c33.129412 18.070588 69.270588 30.117647 105.411765 33.129412V873.411765c0 18.070588 12.047059 30.117647 30.117647 30.117647s30.117647-12.047059 30.117647-30.117647v-63.247059c135.529412-15.058824 240.941176-129.505882 240.941177-268.047059v-30.117647c0-18.070588-15.058824-30.117647-30.117648-30.117647z m-451.764705 30.117647c0-18.070588-12.047059-30.117647-30.117647-30.117647s-30.117647 12.047059-30.117648 30.117647v30.117647c0 75.294118 30.117647 144.564706 84.329412 195.764706l42.164706-42.164706C325.270588 656.564706 301.176471 599.341176 301.176471 542.117647v-30.117647z",
        "fill": "#5F667A"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M864.376471 159.623529c-12.047059-12.047059-30.117647-12.047059-42.164706 0l-662.588236 662.588236c-9.035294 12.047059-6.023529 33.129412 6.02353 42.164706 12.047059 9.035294 24.094118 9.035294 36.141176 0l662.588236-662.588236c9.035294-12.047059 9.035294-30.117647 0-42.164706z",
        "fill": "#825865"
      }
    }
  ]
})
    }
  